/*
 * Bank payouts filters in the URL: view (shell-read, see deleted_alert), claims status and holiday
 * year. Pure parse/serialise; defaults are left out of the URL.
 */
import { CLAIM_STATUSES, CLAIM_STATUS_DEFAULT, holiday_years } from './adapters';
import { PAYOUT_VIEW_KEYS } from './deleted_alert';

export const PAYOUTS_URL_KEYS = ['view', 'status', 'year'];
export const PAYOUTS_DEFAULT_VIEW = 'file';

// status and year only belong to their own section; junk is dropped.
export const parse_payouts_filters = (search, today) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const view = qs.get('view');
  const status = qs.get('status');
  const year = Number(qs.get('year'));
  const years = holiday_years(today);
  return {
    view: PAYOUT_VIEW_KEYS.indexOf(view) !== -1 ? view : PAYOUTS_DEFAULT_VIEW,
    status: CLAIM_STATUSES.some((s) => s.value === status) ? status : CLAIM_STATUS_DEFAULT,
    year: years.indexOf(year) !== -1 ? year : years[0]
  };
};

// {view, status, year} -> the URL values; a section's own filter is written only while it is shown.
export const payouts_query = ({ view, status, year }, today) => ({
  view: view && view !== PAYOUTS_DEFAULT_VIEW ? view : '',
  status: view === 'claims' && status !== CLAIM_STATUS_DEFAULT ? status : '',
  year: view === 'holidays' && year !== holiday_years(today)[0] ? String(year) : ''
});
